import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';
import { AppBrowserModule } from './app/app.browser.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
} else {
  Capacitor.DEBUG = true;
}

platformBrowser()
  .bootstrapModule(AppBrowserModule)
  .catch((err: Error) => {
    console.error(err);
  });
